import config from '../config';

const getFilePrefix = (uuid?: string) => {
  return uuid ? `${config.API_URL}/file/download?uuid=${uuid}` : '';
}
export default getFilePrefix;
